<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div id="app" >
    <!-- <Translator /> -->
 
		<router-view ></router-view>
    
	</div>
</template>
 
<script>
import themeConfig from "@/../themeConfig.js";
import jwt from "@/http/requests/auth/jwt/index.js";
import axios from "axios/index.js"
import moduleUserNotification from "@/store/userNotification/moduleUserNotification.js";
// import { Translator } from 'vue-google-translate';
export default {
 components: {
    // Translator
  },
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
     "$vs.rtl"(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
    },
    "$i18n.locale"(val) {
      switch (val) {
        case "ar":
          Validator.localize("ar", ar);
          break;

        case "en":
          Validator.localize("en", en);

          break;
        case "fr":
          Validator.localize("fr", fr);

          break;
        default:
          Validator.localize("en", en);
          break;
      }
    }
  },
  methods: {
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    }
  },
  mounted() {
    
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);
    
    console.log(process.env.VUE_APP_MY_ENV_VARIABLE)
    //  window.onfocusout = function () {
    //    alert("window ssss")
    // }
    //window.doGTranslate("en|ar");
  },
  async created() {
     debugger
    if(localStorage.getItem("SaveLang")==null||localStorage.getItem("SaveLang")==undefined){
      localStorage.setItem("SaveLang" , "en") 
    }
    if (localStorage.getItem("SaveLang") === "ar") {
      this.$vs.rtl = true;
    }
    
    let dir = this.$vs.rtl ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);
          
    jwt.init(this);

    window.addEventListener("resize", this.handleWindowResize);
    window.addEventListener("scroll", this.handleScroll);
    var vm=this;
    navigator.serviceWorker.onmessage = (event) => {
      console.log('Message ');
      // var item = document.getElementsByClassName('feather-icon-badge')[0].textContent;
      //   document.getElementsByClassName('feather-icon-badge')[0].textContent=parseInt(item)+1;
        vm.$store.dispatch("fetchNotifications");
    }

   window.addEventListener("focus", function(){
    
      vm.$store.dispatch("fetchNotifications");
    });

    // Auth0
    try {
      await this.$auth.renewTokens();
    } catch (e) {
      console.error(e);
    }
  },
  destroyed() {
    
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style >
@font-face {
  font-family: "UbuntuRegular";
  src: local("futura"),url(./assets/fonts/futura/Ubuntu-Regular.ttf) format("truetype");
}
@font-face {
  font-family: "TheSansPlain";
  src: local("futura"),url(./assets/fonts/futura/TheSans_Plain.ttf) format("truetype");
}

body{font-family: "TheSansPlain" !important;}

:lang(ar){font-family: "TheSansPlain";  }
</style>